<template>
    <div>
        <asset-navbar :filterMarket="filterMarket" show-boosts>
            <template v-slot:title>
                <span v-if="market" class="ml-1">{{ market }} market</span>
                <span v-else class="ml-1">???</span>
            </template>
            <template v-slot:subTitle>
            </template>
        </asset-navbar>

        <div v-if="filterMarket && assets.length">
            <div v-if="filterMarket === 'stock' || filterMarket === 'crypto'">
                <rounded-container variant="dark" v-for="(conviction, convictionLabel) in convictionOptions" :key="conviction">
                    <template v-slot:title>
                        {{ convictionLabel }}
                        <span class="text-secondary">
                            {{ byConviction(conviction).length }}</span>
                    </template>

                    <list-assets-table :assetList="byConviction(conviction)" highlight-below-open />
                </rounded-container>

                <rounded-container>
                    <template v-slot:title>
                        snoozed
                        <span class="text-secondary">{{ snoozedAssets.length }}</span>
                    </template>
                    <list-assets-table :assetList="snoozedAssets" />
                </rounded-container>

                <div class="text-center my-4">
                    <b-button variant="outline-secondary" size="sm" :to="{ name: 'disabledAssets', params: { market: filterMarket } }">
                        Disabled assets
                    </b-button>
                </div>
            </div>
        </div>
        <div v-else>
            loading screen
        </div>
    </div>
</template>

<script>

import ListAssetsTable from '../components/asset/ListAssetsTable.vue';
import AssetNavbar from '../components/AssetNavbar.vue';
import RoundedContainer from '../components/style/RoundedContainer.vue';

const convictionOptions = {
    'core': '100k',
    'high conviction': 'high',
    'regular': null,
    'low conviction': 'low',
}

export default {
    name: 'Assets',
    components: {
        ListAssetsTable,
        RoundedContainer,
        AssetNavbar,
    },
    props: ['market', 'assets'],
    data() {
        return {
            filterMarket: '',
            convictionOptions: convictionOptions,
        }
    },
    created() {
        this.filterMarket = this.market;
        this.$store.dispatch('loadAssetList');
    },
    computed: {
        liveAssets() {
            return this.assets.filter(asset =>
                asset.market === this.filterMarket && asset.status !== 'disabled');
        },
        snoozedAssets() {
            return this.liveAssets.filter(asset => asset.acts_like_conviction === 'snoozed');
        },
    },
    methods: {
        byConviction(conviction) {
            return this.liveAssets.filter(asset => asset.conviction === conviction);
        },
    },
    watch: {
        $route(to) {
            // force content refresh when switching props
            this.filterMarket = to.params.market;
        }
    }
};
</script>
